import { call, fork, take } from 'redux-saga/effects';

import { confirmRegistration } from './actions';
import { history } from '../../main';
import apiService from '../../api/apiServices/apiService';
import { toast } from 'react-toastify';
import type { ConfirmResponseDto } from '@poker-stats/contracts';
import i18n from '../../../i18n';

function* watchConfirm() {
  while (true) {
    const { payload }: ReturnType<typeof confirmRegistration> = yield take(
      confirmRegistration.type,
    );

    const { success, reject } = yield call([apiService, apiService.confirm], payload);

    if (success) {
      const response = success.payload as ConfirmResponseDto | undefined;
      toast.success(
        i18n.t(
          response?.result === 'password_reset'
            ? 'password_reset_completed'
            : 'registration_confirmed',
        ),
      );
    }

    if (reject) {
      toast.error(reject.payload.message);
    }

    history.push(`/`);
  }
}

export default function* confirmSaga() {
  yield fork(watchConfirm);
}
